import { ActionSheetOptions } from '@ionic/core/dist/types/components/action-sheet/action-sheet-interface';
import { OverlayController } from '@ionic/core/dist/types/utils/overlays-interface';

let aCtr: any = null;

export const ActionSheetHelper = {
	getInstance: async function (): Promise<OverlayController> {
		if (!aCtr) {
			const { actionSheetController } = await import('@/ionic.loader');
			aCtr = actionSheetController;
		}
		return aCtr;
	},

	openActionSheet: async function (options: ActionSheetOptions, onCloseCallback?: Function) {
		const actionSheet = await (await this.getInstance()).create(options);

		// Only way to silence typescript
		// @ts-ignore
		actionSheet.present();

		// @ts-ignore
		const modalData = await actionSheet.onDidDismiss();
		if (onCloseCallback) {
			onCloseCallback();
		}
		return modalData.data;
	},

	close: (): Promise<boolean> => {
		return aCtr?.dismiss();
	},
};
